<template>
  <div class="bg-white rounded p-3" style="height: 30em">
    <h3 class="font-weight-bolder">Top brokers</h3>
    <hr />
    <div v-for="(broker, index) in topBrokers" :key="index">
      <b-row>
        <b-col cols="2"
          ><i class="fa fa-user-circle" style="fontSize: 2.5em"></i
        ></b-col>
        <b-col cols="6">
          <h4>{{ broker.name }}</h4>
        </b-col>
        <b-col class="font-policies" cols="4">{{ broker.policies }} policies</b-col>
      </b-row>
      <hr class="margin-hr" v-if="index !== topBrokers.length - 1" />
    </div>
  </div>
</template>

<script>
import { getReportingProducts, REPORTING_PRODUCT_CODES } from "../../helpers/reportingProducts";
import { isBoundStatus } from "../../helpers/reportingStatuses";

export default {
  name: "top-broker",
  props: {
    dataChart: {
      type: Array,
      required: true
    },
    reportingProducts: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      topBrokers: []
    };
  },
  computed: {
    productCodes() {
      const products = this.reportingProducts.length
        ? this.reportingProducts
        : getReportingProducts();
      return products.map((p) => p.Product_code);
    }
  },
  watch: {
    dataChart() {
      this.buildTopBrokers()
    },
    reportingProducts: {
      deep: true,
      handler() {
        this.buildTopBrokers()
      }
    }
  },
  methods: {
    buildTopBrokers() {
      this.topBrokers = []
      const codes = this.productCodes.length ? this.productCodes : REPORTING_PRODUCT_CODES
      const data = _.filter(this.dataChart, (item) => {
        return isBoundStatus(item.status) && codes.includes(item.product);
      });
      const groupByBroker =_.take(_.orderBy(_.values(_.groupBy(data, "broker_id")), function(broker) { return broker.length; }, ['desc']), 4)
      if (groupByBroker.length > 0) {
        groupByBroker.forEach(element => {
          this.topBrokers.push({
            "name": element[0].broker_name,
            "policies": element.length
          })
        });
      }
    }
  },
};
</script>

<style>
  @media only screen and (min-width: 1200px) and (max-width: 1300px) {
    .margin-hr {
      margin-top: 1.5rem;
    }
    .font-policies {
      font-size: 15px;
    }
  }
</style>
